// @ts-nocheck
import { t } from "i18next";

export const getRightsList = () => [
	//Appearance
	{
		type: "appearance",
		label: t("Pages.APPEARANCE"),
		rights: {
			admin: { id: 25, name: "AdminAppearance", state: false},
		}
	},
	//AppFunctions
	{
		label: t("Appearance.APP_FUNCTIONS"),
		type: "appFunctions",
		rights: {
			admin: { id: 26, name: "AdminAppFunctions", state: false},
		}
	},
	//WorkFamillies
	{
		label: t("WorkFamilies.WORK_FAMILLIES"),
		type: "workFamillies",
		rights: {
			admin: { id: 27, name: "AdminWFY", state: false},
		}
	},
	//WorkFunctions
	{
		label: t("WorkFunctions.WORK_FUNCTIONS"),
		type: "workFunctions",
		rights: {
			admin: { id: 28, name: "AdminWFU", state: false},
		}
	},
	//Sites
	{
		label: t("Pages.SITES"),
		type: "sites",
		rights: {
			admin: { id: 29, name: "AdminSites", state: false},
		}
	},
	//Groups
	{
		label: t("Pages.GROUPS"),
		type: "groups",
		rights: {
			admin: { id: 38, name: "AdminGroups", state: false},
		}
	},
	//Users
	{
		label: t("Pages.CONTACTS"),
		type: "users",
		rights: {
			read: { id: 42, name: "ReadEmploye", state: false},
			write: { id: 43, name: "WriteEmploye", state: false},
			modify: { id: 44, name: "ModifyEmploye", state: false},
			admin: { id: 45, name: "AdminEmploye", state: false},
		}
	},
	//Alerts
	{
		label: t("Pages.ALERTS"),
		type: "alerts",
		rights: {
			// read: { id: 1, name: "ReadAlert", state: false},
			// write: { id: 1, name: "WriteAlert", state: false},
			// modify: { id: 1, name: "ModifyAlert", state: false},
			admin: { id: 40, name: "AdminAlert", state: false},
		}
	},
	//News
	{
		label: t("Pages.NEWS"),
		type: "news",
		rights: {
			read: { id: 1, name: "ReadNews", state: false},
			write: { id: 2, name: "WriteNews", state: false},
			modify: { id: 3, name: "ModifyNews", state: false},
			admin: { id: 30, name: "AdminNews", state: false},
		}
	},
	//Ads
	{
		label: t("Pages.OFFERS"),
		type: "ads",
		rights: {
			read: { id: 4, name: "ReadAds", state: false},
			write: { id: 5, name: "WriteAds", state: false},
			modify: { id: 6, name: "ModifyAds", state: false},
			admin: { id: 31, name: "AdminAds", state: false},
		}
	},
	//ProAds
	{
		label: t("Pages.PRO_OFFERS"),
		type: "proAds",
		rights: {
			read: { id: 7, name: "ReadProAds", state: false},
			write: { id: 8, name: "WriteProAds", state: false},
			modify: { id: 9, name: "ModifyProAds", state: false},
			admin: { id: 32, name: "AdminProAds", state: false},
		}
	},
	//Career
	{
		label: t("Pages.CAREERS"),
		type: "career",
		rights: {
			read: { id: 10, name: "ReadCareer", state: false},
			write: { id: 11, name: "WriteCareer", state: false},
			modify: { id: 12, name: "ModifyCareer", state: false},
			admin: { id: 33, name: "AdminCareer", state: false},
		}
	},
	//Articles
	{
		label: t("Pages.ARTICLES"),
		type: "articles",
		rights: {
			read: { id: 13, name: "ReadArticle", state: false},
			write: { id: 14, name: "WriteArticle", state: false},
			modify: { id: 15, name: "ModifyArticle", state: false},
			admin: { id: 34, name: "AdminArticle", state: false},
		}
	},
	//Charts
	{
		label: t("Pages.CHARTS"),
		type: "charts",
		rights: {
			read: { id: 16, name: "ReadChart", state: false},
			write: { id: 17, name: "WriteChart", state: false},
			modify: { id: 18, name: "ModifyChart", state: false},
			admin: { id: 35, name: "AdminChart", state: false},
		}
	},
	//Documents
	{
		label: t("Pages.DOCUMENTS"),
		type: "documents",
		rights: {
			read: { id: 19, name: "ReadDocument", state: false},
			write: { id: 20, name: "WriteDocument", state: false},
			modify: { id: 21, name: "ModifyDocument", state: false},
			admin: { id: 36, name: "AdminDocument", state: false},
		}
	},
	//Animations
	{
		label: t("Pages.AGENDA"),
		type: "animations",
		rights: {
			read: { id: 22, name: "ReadEvent", state: false},
			write: { id: 23, name: "WriteEvent", state: false},
			modify: { id: 24, name: "ModifyEvent", state: false},
			admin: { id: 37, name: "AdminEvent", state: false},
		}
	},
	// Forms
	{
		label: t("Pages.FORMS"),
		type: "forms",
		rights: {
			read: { id: 61, name: "ReadForm", state: false},
			write: { id: 60, name: "WriteForm", state: false},
			modify: { id: 59, name: "ModifyForm", state: false},
			admin: { id: 58, name: "AdminForms", state: false},
		}
	}
];

export function getRightsFromPerms(permsObj) {
	if (!permsObj)
		return ({});

	let RightsList = getRightsList();
	let retRights = RightsList.map((perms) => {
		let ret = JSON.parse(JSON.stringify(perms));
		for (let x in perms.rights)
		{
			ret.rights[x] = {...perms.rights[x]};
			ret.rights[x].state = permsObj[perms.rights[x].name] || false;
		}
		return (ret);
	});
	return (retRights);
}

export function getPermsOfRights(rights) {
	if (!rights)
		return ([]);

	let retPerms = [];
	rights.forEach((perm) => {
		for (let x in perm.rights)
			if (perm.rights[x].state)
				retPerms.push(perm.rights[x]);
	});
	return (retPerms);
}

export const BasicRights = {
	ReadEmploye: true,
	ReadNews: true,
	ReadProAds: true,
	ReadAds: true,
	ReadArticle: true,
	ReadCareer: true,
	ReadChart: true,
	ReadDocument: true,
	ReadEvent: true,
	ReadForm: true,
};

export const UserRights = {
	...BasicRights,
	WriteAds: true,
	WriteProAds: true,
	WriteNews: true
};

export const AdminRights = {
	...UserRights,
	AdminAds: true,
	ModifyAds: true,
	AdminAlert: true,
	WriteCareer: true,
	ModifyCareer: true,
	AdminCareer: true,
	WriteDocument: true,
	ModifyDocument: true,
	AdminDocument: true,
	WriteEmploye: true,
	ModifyEmploye: true,
	AdminEmploye: true,
	WriteEvent: true,
	ModifyEvent: true,
	AdminEvent: true,
	AdminGroups: true,
	ModifyNews: true,
	AdminNews: true,
	WriteProAds: true,
	ModifyProAds: true,
	AdminProAds: true,
	WriteForm: true,
	ModifyForm: true,
	AdminForms: true,
};

export const SuperAdminRights = {
	...AdminRights,
	AdminAppearance: true,
	AdminAppFunctions: true,
	WriteArticle: true,
	ModifyArticle: true,
	AdminArticle: true,
	WriteChart: true,
	ModifyChart: true,
	AdminChart: true,
	AdminSites: true,
	AdminWFU: true,
	AdminWFY: true,
};

export const EloAdminRights = {
	...SuperAdminRights
};
